import "./AddCheckPointModal.styles.css";
import {useEffect, useState} from "react";
import {
  Box,
  Button,
  Card, CardActionArea,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {AddCheckPointModalProps} from "./AddCheckPointModal.props";
import {CHECK_DEFINITIONS, HeaderCheck} from "../../../pages/HeaderAnalysis/headerAnalysisRuleModel";

const protocols = [
  {
    id: "DMARC",
    title: "DMARC",
    sub: "Domain-based Auth Reporting",
    desc:
      "Prevents email spoofing by aligning SPF and DKIM results with your domain policy."
  },
  {
    id: "SPF",
    title: "SPF",
    sub: "Sender Policy Framework",
    desc:
      "Specifies which mail servers are allowed to send emails on behalf of your domain."
  },
  {
    id: "DKIM",
    title: "DKIM",
    sub: "DomainKeys Identified Mail",
    desc:
      "Adds a digital signature to outgoing emails to verify they haven't been tampered with."
  },
  {
    id: "ARC",
    title: "ARC",
    sub: "Authenticated Received Chain",
    desc:
      "Preserves authentication results when emails are forwarded through intermediaries."
  }
];

const checksSPF = [
  {
    id: 1,
    type: 'Authentication',
    title: "SPF Authentication check",
    desc:
      "Trigger the rule if SPF verification fails for the sender's domain."
  },
  {
    id: 2,
    type: 'Alignment',
    title: "SPF Alignment check",
    desc:
      "Trigger the rule if the SPF-authenticated domain doesn't align with the sender's 'From' header domain."
  }
];

const checksDMARC = [
  {
    id: 1,
    type: 'Authentication',
    title: "DMARC Authentication check",
    desc:
      "Trigger the rule if DNS records or email authentication are misconfigured."
  },
  {
    id: 2,
    type: 'Compliance',
    title: "DMARC Compliance check",
    desc:
      "Trigger the rule if your setup doesn't meet industry best practices or standards."
  }
];

const checksDKIM = [
  {
    id: 1,
    type: 'Authentication',
    title: "DKIM Authentication check",
    desc:
      "Trigger the rule if DKIM signature verification fails for the sender's domain."
  },
  {
    id: 2,
    type: 'Alignment',
    title: "DKIM Alignment check",
    desc:
      "Trigger the rule if the DKIM-authenticated domain doesn't align with the sender's 'From' header domain."
  }
];

const checksARC = [
  {
    id: 1,
    type: 'Validation',
    title: "ARC Chain Validation check",
    desc:
      "Trigger the rule if the ARC chain validation fails, indicating the message's authentication results were broken in transit."
  },
];

export const AddCheckPointModal: React.FC<AddCheckPointModalProps> = ({open, onClose, onSave,mode,selectedData={}}) => {

  const [selectedProtocol, setSelectedProtocol] = useState("DMARC");
  // const [selectedChecks, setSelectedChecks] = useState([1, 2]);
  const [selectedChecks, setSelectedChecks] = useState(1);
  const [checks, setChecks] = useState<any[]>(checksDMARC);

  // const toggleCheck = (id :any) => {
  //     setSelectedChecks((prev) =>
  //         prev.includes(id)
  //             ? prev.filter((x) => x !== id)
  //             : [...prev, id]
  //     );
  // };
  const handleChecked = (value: string, type?:string) => {
    setSelectedProtocol(value)
    setSelectedChecks(1)
    switch (value) {
      case 'SPF':
        setChecks(checksSPF);
        if(type){
          const selected = checksSPF.filter(x=>x.type ===type)
          setSelectedChecks(selected[0].id)
        }
        break;
      case 'DMARC':
        setChecks(checksDMARC);
        if(type){
          const selected = checksDMARC.filter(x=>x.type ===type)
          setSelectedChecks(selected[0].id)
        }
        break;
      case 'DKIM':
        setChecks(checksDKIM);
        if(type){
          const selected = checksDKIM.filter(x=>x.type ===type)
          setSelectedChecks(selected[0].id)
        }
        break;
      case 'ARC':
        setChecks(checksARC);
        if(type){
          const selected = checksARC.filter(x=>x.type ===type)
          setSelectedChecks(selected[0].id)
        }
        break;
    }
  }
  const handleAdd=()=>{
    const valueChecks=checks.filter(x=>x.id===selectedChecks)
    const selectedDefinition = Object.entries(CHECK_DEFINITIONS).find(([, definition]) => (
      definition.protocol === selectedProtocol && definition.type === valueChecks[0]?.type
    ));
    if (!selectedDefinition) return;
    const params ={
      id: selectedData?.id,
      name: selectedProtocol,
      type: valueChecks[0]?.type || '',
      check: selectedDefinition[0] as HeaderCheck,
      status: "Fail",
      operator:''
    }
    onSave && onSave(params)
  }

  useEffect(() => {
    if (!open) return;
    if(selectedData && Object.keys(selectedData).length > 0){
      const definition = selectedData.check
        ? CHECK_DEFINITIONS[selectedData.check as HeaderCheck]
        : {protocol: selectedData.name, type: selectedData.type};
      handleChecked(definition.protocol, definition.type)
    } else {
      handleChecked('DMARC');
    }
  }, [open, selectedData]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: 1000
        }
      }}
      className={'add-check-point'}
    >
      <DialogTitle
        className={'add-check-point-title'}
      >
        {mode === 'Edit' ? 'Edit Email Authentication Check' : 'Add Email Authentication Checks'}

        <IconButton onClick={onClose}>
          <CloseIcon/>
        </IconButton>
      </DialogTitle>

      <Divider/>

      <DialogContent
        sx={{mt: 1}}
        className={'add-check-point-content'}
      >
        <Typography className={'add-check-point-step'}>
          Step 1 - Select Protocol
        </Typography>

        <Grid container spacing={'12px'} wrap="nowrap" className={'add-check-point-protocal'}>
          {protocols.map((item) => {
            const active = item.id === selectedProtocol;
            return (
              <Grid item xs={12} md={6} key={item.id}>
                <Card
                  onClick={() => handleChecked(item.id)}
                  className={'add-check-point-card'}
                  sx={{
                    border: active
                      ? "2px solid #0E4F83"
                      : "1px solid #d9d9d9",
                    backgroundColor: active ? '#EFF6FF' : '',
                    height: 136,
                  }}
                >
                  <CardContent className={'add-check-point-card-content'}>
                    <Typography
                      className={'card-title'}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      className={'card-caption'}
                      variant="caption"
                    >
                      {item.sub}
                    </Typography>

                    <Divider sx={{my: 1}}/>

                    <Typography
                      className={'card-body'}
                      variant="body2"
                      fontSize={'12px'}
                    >
                      {item.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        <Typography
          className={'add-check-point-step'}
          mt={4}
        >
          Step 2 - Select Failure Checks
        </Typography>

        <Grid container spacing={2} className={'add-check-point-checks'}>
          {checks.map((item) => {
            // const active = selectedChecks.includes(item.id);
            const active = selectedChecks === item.id;
            return (
              <Grid item xs={12} md={6} key={item.id}>
                <Card
                  className={'add-check-point-card'}
                  sx={{
                    border: active
                      ? "2px solid #0E4F83"
                      : "1px solid #d9d9d9",
                    backgroundColor: active ? '#EFF6FF' : '',
                    minHeight: '113px'
                  }}
                  onClick={() =>
                    setSelectedChecks(item.id)
                  }
                >
                  <CardContent className={'add-check-point-card-content'}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      height={'23px'}
                      mb={1}
                    >
                      {/*<Checkbox*/}
                      {/*    checked={active}*/}
                      {/*    onChange={() =>*/}
                      {/*        toggleCheck(item.id)*/}
                      {/*    }*/}
                      {/*/>*/}

                      <Typography
                        className={'card-title'}
                      >
                        {item.title}
                      </Typography>

                      <Chip
                        className={'chip-checks'}
                        label="Fail"
                        size="small"
                        sx={{
                          "& .MuiChip-label": {
                            px: 1,
                          },
                        }}
                      />
                    </Stack>
                    <Divider/>
                    <Typography
                      className={'card-body'}
                      mt={1}
                      variant="body2"
                      fontSize={12}
                      fontWeight={400}
                    >
                      {item.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>

      <Divider/>

      <DialogActions sx={{p: 2}}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{textTransform: "none"}}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            px: 4
          }}
          onClick={handleAdd}
        >
          {mode === 'Edit' ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  )
};
